export class CPPCOIRequestItemsFilter {
  itemNo: string;
  clearAll: boolean;
  productName: string;
  packageSize: string;
  vendorName: string;
  productLine: string;
}
